import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
// Projects page hidden — it duplicates the "Featured Work" section already shown on Home.
// Re-enable the import and route below once there are enough projects to justify a separate page.
// import Projects from './pages/Projects';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Notes from './pages/Notes';
import NoteDetail from './pages/NoteDetail';
import ReactTutorial from './pages/tutorials/ReactTutorial';
import PythonTutorial from './pages/tutorials/PythonTutorial';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        {/* <Route path="/projects" element={<Projects />} /> */}
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/notes" element={<Notes />} />
        <Route path="/notes/:slug" element={<NoteDetail />} />
        <Route path="/react" element={<ReactTutorial />} />
        <Route path="/python" element={<PythonTutorial />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
